import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";

const MySwal = withReactContent(Swal2);

const AddLawsuit = (props) => {
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("");
  const [petitionersC, setPetitionersC] = useState("");
  const [indexedC, setIndexedC] = useState("");
  const [payedC, setPayedC] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [task, setTask] = useState("");
  const [lawsuits, setLawsuits] = useState([]);
  const [plnValue, setPlnValue] = useState(
    props.clientsData.nadPLN
      ? props.clientsData.nadPLN
      : props.clientsData.wezwPlnValue
      ? props.clientsData.wezwPlnValue
      : 0
  );
  const [chfValue, setChfValue] = useState(
    props.clientsData.nadCHF
      ? props.clientsData.nadCHF
      : props.clientsData.wezwChfValue
      ? props.clientsData.wezwChfValue
      : 0
  );
  const [lastPaymentDate, setLastPaymentDate] = useState(
    props.clientsData.wezwLastPayDate === null
      ? 0
      : props.clientsData.wezwLastPayDate
  );
  const [payTime, setPayTime] = useState(
    props.clientsData.wezwPayTime === null ? 0 : props.clientsData.wezwPayTime
  );
  const [bank, setBank] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [bankAddressDb, setBankAddressDb] = useState("");
  const [curr, setCurr] = useState("");
  const [curr_old, setCurr_old] = useState("");
  const [dateOpt, setDateOpt] = useState(
    props.clientsData.wezwLastPayDate === null ||
      props.clientsData.wezwLastPayDate === "całkowitej spłaty kredytu"
      ? "2"
      : "1"
  );
  const [lawyersData, setLawyersData] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [court, setCourt] = useState("");
  const [courtDistrict, setCourtDistrict] = useState("");
  const [aggr_points, setAggr_points] = useState("");
  const [questions, setQuestions] = useState("");
  const [checklist, setCheckList] = useState([]);
  const [text, setText] = useState([]);
  const [list, setList] = useState([]);

  const fetchBankAddress = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            nameSelect: el.nameSelect,
            nameLetter: el.nameLetter,
            bankKRS: el.bankKRS,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });
        setBankAddressDb(
          arr.filter((el) => el.nameSelect === props.clientsData.bank)[0]
        );
        fetchLawyers();
      })
      .catch((error) => {});
  };

  const fetchCourtAddress = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCourtAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            try {
              data = JSON.parse(el.addressNew);
              console.log(data);
            } catch (err) {
              console.log(err);
            }
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            district: el.district,
            name: el.name,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });

        getCurr();
        var districtTxt =
          props.district === "brak"
            ? "Wydział Cywilny"
            : props.district + " Wydział Cywilny";
        if (props.clientsData.aCourt === "Sąd Okręgowy w Warszawie") {
          districtTxt = "XXVIII Wydział Cywilny";
        }
        if (
          props.clientsData.aCourt === "Sąd Okręgowy w Poznaniu" &&
          props.district === "XIV"
        ) {
          districtTxt = "XIV Zamiejscowy Wydział Cywilny z siedzibą w Pile";
        }
        setCourt(
          districtTxt +
            "\n" +
            (districtTxt === "XXVIII Wydział Cywilny"
              ? "ul. Przyokopowa 33, 01-208 Warszawa"
              : props.district === "brak"
              ? arr.filter((el) => el.name === props.clientsData.aCourt)[0]
                  .address
              : arr.filter(
                  (el) =>
                    el.name === props.clientsData.aCourt &&
                    el.district.includes(props.district)
                )[0].address)
        );
        setCourtDistrict(districtTxt);
      })
      .catch((error) => {});
  };

  const getCurr = async () => {
    console.log("asds");
    var url = "";
    var day = new Date().getDay();
    var dateX = new Date();
    if (day === 0) {
      dateX = subDays(new Date(), 6);
    }
    if (day === 6) {
      dateX = subDays(new Date(), 5);
    }

    var date =
      new Date(dateX).getFullYear() +
      "-" +
      (new Date(dateX).getMonth() + 1 < 10
        ? "0" + (new Date(dateX).getMonth() + 1)
        : new Date(dateX).getMonth() + 1) +
      "-" +
      (new Date(dateX).getDate() < 10
        ? "0" + new Date(dateX).getDate()
        : new Date(dateX).getDate());

    console.log(date);

    url = `https://api.nbp.pl/api/exchangerates/rates/a/chf/${date}`;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setCurr(data.rates[0].mid);
        getCurr_old();
      })
      .catch(async (error) => {
        console.log(error);
        var dateY = subDays(new Date(), 1);
        var date2 =
          new Date(dateY).getFullYear() +
          "-" +
          (new Date(dateY).getMonth() + 1 < 10
            ? "0" + (new Date(dateY).getMonth() + 1)
            : new Date(dateY).getMonth() + 1) +
          "-" +
          (new Date(dateY).getDate() < 10
            ? "0" + new Date(dateY).getDate()
            : new Date(dateY).getDate());

        url = `https://api.nbp.pl/api/exchangerates/rates/a/chf/${date2}`;

        await fetch(url)
          .then((response) => response.json())
          .then((data) => {
            setCurr(data.rates[0].mid);
            getCurr_old();
          })
          .catch((error) => {
            console.log(error);
            setCurr(0);
            getCurr_old();
          });
      });
  };

  const getCurr_old = async () => {
    var url = "";
    var day = new Date(props.clientsData.dateWym).getDay();
    var dateX = new Date(props.clientsData.dateWym);
    if (day === 0) {
      dateX = subDays(new Date(props.clientsData.dateWym), 6);
    }
    if (day === 6) {
      dateX = subDays(new Date(props.clientsData.dateWym), 5);
    }
    var date =
      new Date().getFullYear() +
      "-" +
      (new Date(dateX).getMonth() < 10
        ? "0" + (new Date(dateX).getMonth() + 1)
        : new Date(dateX).getMonth() + 1) +
      "-" +
      (new Date(dateX).getDate() < 10
        ? "0" + new Date(dateX).getDate()
        : new Date(dateX).getDate());

    url = `https://api.nbp.pl/api/exchangerates/rates/a/chf/${date}`;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCurr_old(data.rates[0].mid);
        fetchAggrPoints();
      })
      .catch((error) => {
        setCurr_old(0);
        fetchAggrPoints();
      });
  };

  const fetchAggrPoints = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getAggrPoints", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAggr_points(
          data.filter(
            (el) =>
              el.bank === props.clientsData.bank &&
              new Date(props.clientsData.credit_date).getFullYear() === +el.year
          ).length === 0
            ? data.filter(
                (el) => el.bank === props.clientsData.bank && "brak" === el.year
              )[0].points
            : data.filter(
                (el) =>
                  el.bank === props.clientsData.bank &&
                  new Date(props.clientsData.credit_date).getFullYear() ===
                    +el.year
              )[0].points
        );

        fetchLawsuits();
      })
      .catch((error) => {
        fetchLawsuits();
      });
  };

  const fetchLawsuits = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLettersLawsuit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (props.clientsData.type === "sankcja kredytu darmowego") {
          setLawsuits(
            data
              .filter((e) => e.type === "SKD")
              .filter((el) => el.questions)
              .filter((q) => q.questions.length > 0)
          );
        } else {
          setLawsuits(
            data
              .filter((e) => e.type === "CHF")
              .filter((el) => el.questions)
              .filter((q) => q.questions.length > 0)
          );
        }

        fetchQuestions();
      })
      .catch((error) => {});
  };

  const fetchQuestions = async () => {
    var body = {};

    var url = "https://apidevkppp.ftpeople.pl/getQuestionsCHF";
    if (props.clientsData.type === "sankcja kredytu darmowego") {
      url = "https://apidevkppp.ftpeople.pl/getQuestionsSKD";
    }
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setQuestions(data);
        var qstX = [];
        data.map((e, index) => {
          var obj = { question: e.name, result: "NIE", index: index };
          qstX.push(obj);
        });
        setCheckList(qstX);

        fetchResults();
      })
      .catch((error) => {});
  };

  const fetchResults = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitText", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setText(data);
        fetchResultsList();
      })
      .catch((error) => {});
  };

  const fetchResultsList = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawsuitTextList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setList(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchLawyers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawyers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawyersData(data);
        fetchHolidays();
      })
      .catch((error) => {});
  };

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        setLastPaymentDate(generateLastPayDate());
        fetchCourtAddress();
      })
      .catch((error) => {});
  };

  const generateLastPayDate = () => {
    var date =
      props.clientsData.wezwLastPayDate === null ||
      props.clientsData.wezwLastPayDate === "całkowitej spłaty kredytu"
        ? ""
        : props.clientsData.wezwLastPayDate;

    if (date !== "") {
      date = date.replaceAll("r.", "");
      var dateA = date.split(" ");
      var day = dateA[0];
      var month = getMonthNumber(dateA[1]);
      var year = dateA[2];

      return year + "-" + month + "-" + day;
    } else {
      return date;
    }
  };

  const getData = async () => {
    fetchBankAddress();
  };

  useEffect(() => {
    console.log(props.clientsData.lawZaswDate2 === null);
    console.log(new Date(props.clientsData.lawZaswDate3));
    getData();
  }, []);

  function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
  }

  const generateClientName = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      table.map((el, index) => {
        text = text + el + (index + 1 === table.length ? "" : ", ");
      });
      return text.toString();
    } else {
      return table;
    }
  };

  const getMonthName = (month) => {
    if (month === 1) {
      return "stycznia";
    }
    if (month === 2) {
      return "lutego";
    }
    if (month === 3) {
      return "marca";
    }
    if (month === 4) {
      return "kwietnia";
    }
    if (month === 5) {
      return "maja";
    }
    if (month === 6) {
      return "czerwca";
    }
    if (month === 7) {
      return "lipca";
    }
    if (month === 8) {
      return "sierpnia";
    }
    if (month === 9) {
      return "września";
    }
    if (month === 10) {
      return "października";
    }
    if (month === 11) {
      return "listopada";
    }
    if (month === 12) {
      return "grudnia";
    }
  };

  const getMonthNumber = (month) => {
    if (month === "stycznia") {
      return "01";
    }
    if (month === "lutego") {
      return "02";
    }
    if (month === "marca") {
      return "03";
    }
    if (month === "kwietnia") {
      return "04";
    }
    if (month === "maja") {
      return "05";
    }
    if (month === "czerwca") {
      return "06";
    }
    if (month === "lipca") {
      return "07";
    }
    if (month === "sierpnia") {
      return "08";
    }
    if (month === "września") {
      return "09";
    }
    if (month === "października") {
      return "10";
    }
    if (month === "listopada") {
      return "11";
    }
    if (month === "grudnia") {
      return "12";
    }
  };

  const numberWithCommas = (x) => {
    return x
      .toString()
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ")
      .replaceAll(".", ",");
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validate = () => {
    return true;
    if (petitioners && indexed && payed) {
      return true;
    }
    return false;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addDayThree = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 3));
    return retDate;
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= final_date && el.date_from <= final_date) ||
          (final_date >= el.date_from && final_date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const getAddress = (el) => {
    var additionalData = props.clientsData.additionalData;
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[2]
        .replaceAll(";", ",");
    } else {
      return "";
    }
  };

  const getPesel = (el) => {
    var additionalData = props.clientsData.additionalData;
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[1];
    } else {
      return "";
    }
  };

  const getPetitionerData = () => {
    var table =
      props.clientsData.petitioner.replaceAll("  ", "").split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;

    var arr = [];

    if (isArray(table)) {
      table.map((el, index) => {
        arr.push({
          name: el,
          address: ", " + getAddress(el) + ", PESEL: " + getPesel(el),
        });
      });
      return arr;
    } else {
      return [
        {
          name: table,
          address: ", " + getAddress(table) + ", PESEL: " + getPesel(table),
        },
      ];
      //return table + ", " + getAddress(table) + ", PESEL: " + getPesel(table);
    }
  };

  const getPetitionerDataAddress = () => {
    var table =
      props.clientsData.petitioner.replaceAll("  ", "").split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      table.map((el, index) => {
        text =
          text +
          "\n" +
          ", " +
          getAddress(el) +
          ", PESEL: " +
          getPesel(el) +
          (index + 1 === table.length ? "" : ", ");
      });
      return text.toString();
    } else {
      return table + ", " + getAddress(table) + ", PESEL: " + getPesel(table);
    }
  };

  const subDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 1));
    return retDate;
  };

  const subDays = (date, days) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - days));
    return retDate;
  };

  const generateDocument = async () => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }
    var model = [];
    console.log(JSON.stringify(checklist));
    console.log(lawsuits[0].questions);
    console.log(_.isEqual(lawsuits[0].questions, JSON.stringify(checklist)));
    console.log(
      lawsuits.filter((el) =>
        _.isEqual(el.questions, JSON.stringify(checklist))
      )
    );
    lawsuits
      .filter((el) => _.isEqual(el.questions, JSON.stringify(checklist)))
      .map((element) => {
        model[element.link] = element.name;
      });

    if (
      lawsuits.filter((el) =>
        _.isEqual(el.questions, JSON.stringify(checklist))
      ).length === 0
    ) {
      MySwal.fire({
        icon: "error",
        title: "Nie znaleziono",
        text: "szablonu pozwu dla podanych danych",
      }).then(async (result) => {});
      return;
    }

    MySwal.fire({
      title: "Wybierz wzór pozwu z dostępnych opcji",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz wzór",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać wzór");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var link = result.value;
        var law = lawsuits.filter((el) => el.link === link)[0];
        var qstR = JSON.parse(law.questions);
        console.log(qstR);
        var petitioners = "NIE";
        var indexed = "NIE";
        var payed = "NIE";
        if (props.clientsData.type !== "sankcja kredytu darmowego") {
          petitioners = qstR[0].result;
          indexed = qstR[1].result;
          payed = qstR[2].result;
        } else {
          petitioners = qstR[0].result;
          payed = qstR[1].result;
          indexed = "NIE";
        }

        loadFile(link, function (error, content) {
          if (error) {
            console.log(error);
            throw error;
          }
          var zip = new PizZip(content);
          var doc = new Docxtemplater(zip, {
            paragraphLoop: true,
            linebreaks: true,
          });

          console.log(petitioners);
          console.log(payed);
          console.log(indexed);
          var plnValueTr2 =
            +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? numberWithCommas(
                  parseFloat(
                    parseFloat(
                      +props.clientsData.wezwPlnValue
                        .replaceAll(" ", "")
                        .replaceAll(",", ".") +
                        +props.clientsData.wezwChfValue
                          .toString()
                          .replaceAll(" ", "")
                          .replaceAll(",", ".") *
                          curr +
                        +props.clientsData.credit_value
                          .split(" ")[0]
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                    ).toFixed(2)
                  ).toFixed(2)
                )
              : "";

          var plnValueTr3 =
            +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? numberWithCommas(
                  parseFloat(
                    parseFloat(
                      +props.clientsData.wezwPlnValue
                        .replaceAll(" ", "")
                        .replaceAll(",", ".") +
                        (+props.clientsData.wezwChfValue
                          .replaceAll(" ", "")
                          .replaceAll(",", ".") > 0
                          ? +props.clientsData.wezwChfValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".") * curr
                          : 0)
                    ).toFixed(2)
                  ).toFixed(2)
                )
              : "";
          var plnValueTr4 =
            +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? numberWithCommas(
                  Math.ceil(
                    parseFloat(
                      +props.clientsData.wezwPlnValue
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")
                    )
                  )
                )
              : "";
          var plnValueTr =
            props.clientsData.nadPLN || plnValue
              ? numberWithCommas(
                  parseFloat(
                    parseFloat(
                      props.clientsData.nadPLN
                        ? +props.clientsData.nadPLN
                            .replaceAll(" ", "")
                            .replaceAll(",", ".")
                        : +props.clientsData.wezwPlnValue
                            .replaceAll(" ", "")
                            .replaceAll(",", ".")
                    ).toFixed(2)
                  ).toFixed(2)
                )
              : "asdasd";

          var plnValueTrA = props.clientsData.wezwPlnValue
            ? numberWithCommas(
                parseFloat(
                  parseFloat(
                    +props.clientsData.wezwPlnValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".")
                  ).toFixed(2)
                ).toFixed(2)
              )
            : "asdasd";
          var plnTextTr =
            +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? " PLN"
              : "";
          var chfValueTr = numberWithCommas(
            parseFloat(
              parseFloat(
                +props.clientsData.wezwChfValue
                  .toString()
                  .replaceAll(" ", "")
                  .replaceAll(",", ".")
              ).toFixed(2)
            ).toFixed(2)
          );
          var dateWezwTxt =
            (new Date(props.clientsData.data_wezw).getDate() < 10
              ? "0" + new Date(props.clientsData.data_wezw).getDate()
              : new Date(props.clientsData.data_wezw).getDate()) +
            " " +
            getMonthName(new Date(props.clientsData.data_wezw).getMonth() + 1) +
            " " +
            new Date(props.clientsData.data_wezw).getFullYear() +
            " r.";
          var dateDeliwerTxt =
            (new Date(props.clientsData.dateDeliverWezw).getDate() < 10
              ? "0" + new Date(props.clientsData.dateDeliverWezw).getDate()
              : new Date(props.clientsData.dateDeliverWezw).getDate()) +
            " " +
            getMonthName(
              new Date(props.clientsData.dateDeliverWezw).getMonth() + 1
            ) +
            " " +
            new Date(props.clientsData.dateDeliverWezw).getFullYear() +
            " r.";
          var datePrintTxt =
            (new Date(props.clientsData.printDate).getDate() < 10
              ? "0" + new Date(props.clientsData.printDate).getDate()
              : new Date(props.clientsData.printDate).getDate()) +
            " " +
            getMonthName(new Date(props.clientsData.printDate).getMonth() + 1) +
            " " +
            new Date(props.clientsData.printDate).getFullYear() +
            " r.";
          var dateSendTxt =
            (new Date(props.clientsData.sendDate).getDate() < 10
              ? "0" + new Date(props.clientsData.sendDate).getDate()
              : new Date(props.clientsData.sendDate).getDate()) +
            " " +
            getMonthName(new Date(props.clientsData.sendDate).getMonth() + 1) +
            " " +
            new Date(props.clientsData.sendDate).getFullYear() +
            " r.";
          var creditDateText =
            (new Date(props.clientsData.credit_date).getDate() < 10
              ? "0" + new Date(props.clientsData.credit_date).getDate()
              : new Date(props.clientsData.credit_date).getDate()) +
            " " +
            getMonthName(
              new Date(props.clientsData.credit_date).getMonth() + 1
            ) +
            " " +
            new Date(props.clientsData.credit_date).getFullYear() +
            " r.";

          var creditValueCurr = props.clientsData.credit_value.split(" ")[1];
          var creditValueVal = numberWithCommas(
            parseFloat(
              parseFloat(
                props.clientsData.credit_value
                  .split(" ")[0]
                  .replaceAll(" ", "")
                  .replaceAll(",", ".")
              ).toFixed(2)
            ).toFixed(2)
          );
          var creditValueText = creditValueVal + " " + creditValueCurr;

          var zaswDateLaw1Txt =
            props.clientsData.lawZaswDate !== null
              ? (new Date(props.clientsData.lawZaswDate).getDate() < 10
                  ? "0" + new Date(props.clientsData.lawZaswDate).getDate()
                  : new Date(props.clientsData.lawZaswDate).getDate()) +
                " " +
                getMonthName(
                  new Date(props.clientsData.lawZaswDate).getMonth() + 1
                ) +
                " " +
                new Date(props.clientsData.lawZaswDate).getFullYear() +
                " r."
              : "(uzupełnij)";

          var zaswDateLaw2Txt =
            props.clientsData.lawZaswDate2 !== null
              ? (new Date(props.clientsData.lawZaswDate2).getDate() < 10
                  ? "0" + new Date(props.clientsData.lawZaswDate2).getDate()
                  : new Date(props.clientsData.lawZaswDate2).getDate()) +
                " " +
                getMonthName(
                  new Date(props.clientsData.lawZaswDate2).getMonth() + 1
                ) +
                " " +
                new Date(props.clientsData.lawZaswDate2).getFullYear() +
                " r."
              : "(uzupełnij)";

          var zaswDateLaw3Txt =
            props.clientsData.lawZaswDate3 !== null
              ? (new Date(props.clientsData.lawZaswDate3).getDate() < 10
                  ? "0" + new Date(props.clientsData.lawZaswDate3).getDate()
                  : new Date(props.clientsData.lawZaswDate3).getDate()) +
                " " +
                getMonthName(
                  new Date(props.clientsData.lawZaswDate3).getMonth() + 1
                ) +
                " " +
                new Date(props.clientsData.lawZaswDate3).getFullYear() +
                " r."
              : "(uzupełnij)";

          var sum = 0;
          if (
            indexed === "TAK" &&
            props.clientsData.credit_value.split(" ")[1] === "PLN" &&
            (+props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0) &&
            (+props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0 ||
              +props.clientsData.nadPLN
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0)
          ) {
            sum = parseFloat(
              parseFloat(
                +props.clientsData.credit_value
                  .replaceAll(" ", "")
                  .replaceAll(",", ".")
                  .replaceAll("CHF", "")
                  .replaceAll("PLN", "") +
                  (props.clientsData.nadPLN
                    ? +props.clientsData.nadPLN
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")
                    : +props.clientsData.wezwPlnValue
                        .replaceAll(" ", "")
                        .replaceAll(",", "."))
              ).toFixed(2)
            ).toFixed(2);
          }

          if (
            indexed === "TAK" &&
            props.clientsData.credit_value.split(" ")[1] === "PLN" &&
            (props.clientsData.nadCHF
              ? +props.clientsData.nadCHF
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0
              : false ||
                +props.clientsData.wezwChfValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0) &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
          ) {
            sum = parseFloat(
              parseFloat(
                +props.clientsData.credit_value
                  .replaceAll(" ", "")
                  .replaceAll(",", ".")
                  .replaceAll("CHF", "")
                  .replaceAll("PLN", "") +
                  (props.clientsData.nadPLN
                    ? +props.clientsData.nadPLN
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")
                    : +props.clientsData.wezwPlnValue
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")) +
                  (props.clientsData.nadCHF
                    ? +props.clientsData.nadCHF
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")
                    : +props.clientsData.wezwChfValue
                        .toString()
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")) *
                    +curr
              ).toFixed(2)
            ).toFixed(2);
          }

          if (
            indexed === "NIE" &&
            +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0 &&
            (props.clientsData.nadPLN
              ? +props.clientsData.nadPLN
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") !== undefined
              : false ||
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") !== undefined) &&
            (props.clientsData.nadCHF
              ? +props.clientsData.nadCHF
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === undefined
              : false || props.clientsData.nadCHF
              ? +props.clientsData.nadCHF
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === 0
              : false ||
                +props.clientsData.wezwChfValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === undefined ||
                +props.clientsData.wezwChfValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === 0)
          ) {
            sum = parseFloat(
              parseFloat(
                +props.clientsData.realCreditValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") +
                  (props.clientsData.nadPLN
                    ? +props.clientsData.nadPLN
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")
                    : +props.clientsData.wezwPlnValue
                        .replaceAll(" ", "")
                        .replaceAll(",", "."))
              ).toFixed(2)
            ).toFixed(2);
          }

          if (
            indexed === "NIE" &&
            +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0 &&
            props.clientsData.nadPLN
              ? +props.clientsData.nadPLN
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") !== undefined
              : false && props.clientsData.nadPLN
              ? +props.clientsData.nadPLN
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0
              : false &&
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") !== undefined &&
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0 &&
                ((props.clientsData.nadCHF
                  ? +props.clientsData.nadCHF
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") !== undefined
                  : false && props.clientsData.nadCHF
                  ? +props.clientsData.nadCHF

                      .replaceAll(" ", "")
                      .replaceAll(",", ".") > 0
                  : false) ||
                  (+props.clientsData.wezwChfValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") !== undefined &&
                    +props.clientsData.wezwChfValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") > 0))
          ) {
            sum = parseFloat(
              parseFloat(
                (props.clientsData.nadPLN
                  ? +props.clientsData.nadPLN

                      .replaceAll(" ", "")
                      .replaceAll(",", ".")
                  : +props.clientsData.wezwPlnValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".")) +
                  (props.clientsData.nadCHF
                    ? +props.clientsData.nadCHF

                        .replaceAll(" ", "")
                        .replaceAll(",", ".")
                    : +props.clientsData.wezwChfValue
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")) *
                    +curr +
                  +props.clientsData.realCreditValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
              ).toFixed(2)
            ).toFixed(2);
          }
          if (
            indexed === "NIE" &&
            (+props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.realCreditValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0) &&
            ((props.clientsData.nadPLN
              ? +props.clientsData.nadPLN

                  .replaceAll(" ", "")
                  .replaceAll(",", ".") !== undefined
              : false && props.clientsData.nadPLN
              ? +props.clientsData.nadPLN

                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0
              : false) ||
              (+props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") !== undefined &&
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0)) &&
            ((props.clientsData.nadCHF
              ? +props.clientsData.nadCHF

                  .replaceAll(" ", "")
                  .replaceAll(",", ".") !== undefined
              : false && props.clientsData.nadCHF
              ? +props.clientsData.nadCHF

                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0
              : false) ||
              (+props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") !== undefined &&
                +props.clientsData.wezwChfValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0))
          ) {
            sum = parseFloat(
              parseFloat(
                (props.clientsData.nadPLN
                  ? +props.clientsData.nadPLN

                      .replaceAll(" ", "")
                      .replaceAll(",", ".")
                  : +props.clientsData.wezwPlnValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".")) +
                  (props.clientsData.nadCHF
                    ? +props.clientsData.nadCHF

                        .replaceAll(" ", "")
                        .replaceAll(",", ".")
                    : props.clientsData.wezwChfValue
                        .replaceAll(" ", "")
                        .replaceAll(",", ".")) *
                    +curr +
                  +props.clientsData.credit_value
                    .replaceAll("CHF", "")
                    .replaceAll("PLN", "")
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") *
                    +curr
              ).toFixed(2)
            ).toFixed(2);
          }

          if (
            indexed === "NIE" &&
            (+props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.realCreditValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0) &&
            (+props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined ||
              +props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0) &&
            (+props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0)
          ) {
            sum = parseFloat(
              parseFloat(
                (props.clientsData.nadPLN
                  ? +props.clientsData.nadPLN
                      .replaceAll(" ", "")
                      .replaceAll(",", ".")
                  : +props.clientsData.wezwPlnValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".")) +
                  +props.clientsData.credit_value
                    .replaceAll("CHF", "")
                    .replaceAll("PLN", "")
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") *
                    +curr
              ).toFixed(2)
            ).toFixed(2);
          }

          const getList = (name) => {
            console.log(name);
            console.log(list);
            var arr = JSON.parse(
              list.filter((el) => el.topic === name)[0].name
            );
            var arr2 = [];
            arr.map((el) => {
              console.log(el);
              var bo = true;
              if (
                el.value.includes("zaswDateLaw1Txt") &&
                zaswDateLaw1Txt === "(uzupełnij)"
              ) {
                bo = false;
              }

              if (
                el.value.includes("zaswDateLaw2Txt") &&
                zaswDateLaw2Txt === "(uzupełnij)"
              ) {
                bo = false;
              }

              if (
                el.value.includes("zaswDateLaw3Txt") &&
                zaswDateLaw3Txt === "(uzupełnij)"
              ) {
                bo = false;
              }

              if (
                el.value ===
                  "Oświadczenie o potrąceniu z dnia … r. (kserokopia)," &&
                payed !== "TAK"
              ) {
                bo = false;
              }

              if (
                el.value ===
                  "Potwierdzenie nadania oświadczenia o potrąceniu z dnia … r. (kserokopia)," &&
                payed !== "TAK"
              ) {
                bo = false;
              }
              if (
                el.value ===
                  "Wydruk z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia {datePrintTxt} (wydruk)," &&
                payed !== "TAK"
              ) {
                bo = false;
              }

              if (
                el.value ===
                  "Wydruk wygenerowany z systemu Poczty Polskiej S.A. z dnia .......... (wydruk)," &&
                payed !== "TAK"
              ) {
                bo = false;
              }

              console.log(bo);

              var obj = {
                id: el.id,
                value: el.value
                  .replaceAll("{creditDateText}", creditDateText)
                  .replaceAll("{zaswDateLaw1Txt}", zaswDateLaw1Txt)
                  .replaceAll("{zaswDateLaw2Txt}", zaswDateLaw2Txt)
                  .replaceAll("{zaswDateLaw3Txt}", zaswDateLaw3Txt)
                  .replaceAll("{dateWezwTxt}", dateWezwTxt)
                  .replaceAll("{datePrintTxt}", datePrintTxt)
                  .replaceAll("{creditDateText}", creditDateText)
                  .replaceAll("{dateSendTxt}", dateSendTxt),
                bo: bo,
              };
              arr2.push(obj);
            });

            return arr2;
          };

          doc.setData({
            hasInd:
              indexed === "TAK" && props.clientsData.nadPLN
                ? +props.clientsData.nadPLN

                    .replaceAll(" ", "")
                    .replaceAll(",", ".") !== undefined
                : false &&
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") !== undefined &&
                  props.clientsData.nadCHF
                ? +props.clientsData.nadCHF

                    .replaceAll(" ", "")
                    .replaceAll(",", ".") === undefined
                : false &&
                  +props.clientsData.wezwChfValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") === undefined
                ? true
                : false,
            court: props.clientsData.aCourt,
            court_address: court,
            court_district: courtDistrict,
            ge_text_new: props.clientsData.bank_old.includes("Money Bank")
              ? text.filter((el) => el.topic === "ge_text_new").length > 0
                ? text.filter((el) => el.topic === "ge_text_new")[0].name
                : ""
              : "",
            date:
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              " " +
              getMonthName(new Date().getMonth() + 1) +
              " " +
              new Date().getFullYear() +
              " r.",
            hasManyPet: getPetitionerData().length > 1 ? true : false,
            hasNManyPet: getPetitionerData().length === 1 ? true : false,
            petitioner_data: getPetitionerData(),
            pettioner_details:
              "telefon: " +
              props.clientsData.phone +
              ", adres e-mail: " +
              props.clientsData.email,
            knadPLN: props.clientsData.nadPLN
              ? numberWithCommas(parseFloat(props.clientsData.nadPLN)) + " PLN"
              : "",
            knadCHF: props.clientsData.nadCHF
              ? numberWithCommas(parseFloat(props.clientsData.nadCHF)) + " CHF"
              : "",
            data_wezw:
              (new Date(props.clientsData.data_wezw).getDate() < 10
                ? "0" + new Date(props.clientsData.data_wezw).getDate()
                : new Date(props.clientsData.data_wezw).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.data_wezw).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.data_wezw).getFullYear() +
              " r.",
            pot_nad_wezw: props.clientsData.sendDate,
            data_wyd_pot:
              (new Date(props.clientsData.printDate).getDate() < 10
                ? "0" + new Date(props.clientsData.printDate).getDate()
                : new Date(props.clientsData.printDate).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.printDate).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.printDate).getFullYear() +
              " r.",
            data_za_1:
              (new Date(props.clientsData.lawZaswDate).getDate() < 10
                ? "0" + new Date(props.clientsData.lawZaswDate).getDate()
                : new Date(props.clientsData.lawZaswDate).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.lawZaswDate).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.lawZaswDate).getFullYear() +
              " r.",
            data_za_2:
              (new Date(props.clientsData.lawZaswDate2).getDate() < 10
                ? "0" + new Date(props.clientsData.lawZaswDate2).getDate()
                : new Date(props.clientsData.lawZaswDate2).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.lawZaswDate2).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.lawZaswDate2).getFullYear() +
              " r.",
            data_za_3:
              (new Date(props.clientsData.lawZaswDate3).getDate() < 10
                ? "0" + new Date(props.clientsData.lawZaswDate3).getDate()
                : new Date(props.clientsData.lawZaswDate3).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.lawZaswDate3).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.lawZaswDate3).getFullYear() +
              " r.",

            bank:
              bankAddressDb.nameLetter === undefined
                ? "............."
                : bankAddressDb.nameLetter,
            bank2: props.clientsData.bank_old
              ? props.clientsData.bank_old
              : bankAddressDb && bankAddressDb !== "undefined"
              ? bankAddressDb.nameLetter
              : props.clientsData.bank,
            bank_address:
              bankAddressDb.address === undefined
                ? "............."
                : bankAddressDb.address,
            bank_krs:
              bankAddressDb.bankKRS === undefined
                ? "............."
                : bankAddressDb.bankKRS,
            wps_add: true
              ? ""
              : +props.clientsData.wezwChfValue > 0
              ? "\n" +
                "WPS: " +
                numberWithCommas(
                  parseFloat(
                    parseFloat(
                      (props.clientsData.nadPLN
                        ? +props.clientsData.nadPLN

                            .replaceAll(" ", "")
                            .replaceAll(",", ".")
                        : +props.clientsData.wezwPlnValue
                            .replaceAll(" ", "")
                            .replaceAll(",", ".")) +
                        +props.clientsData.realCreditValue
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                    ).toFixed(0)
                  ).toFixed(2)
                ) +
                " PLN + " +
                numberWithCommas(
                  parseFloat(props.clientsData.wezwChfValue).toFixed(2)
                ) +
                " CHF"
              : "",
            wps_sum:
              "WPS: " +
              numberWithCommas(Math.ceil(parseFloat(sum)).toFixed(2)) +
              " PLN",
            date_wym:
              (new Date(props.clientsData.dateWym).getDate() < 10
                ? "0" + new Date(props.clientsData.dateWym).getDate()
                : new Date(props.clientsData.dateWym).getDate()) +
              " " +
              getMonthName(new Date(props.clientsData.dateWym).getMonth() + 1) +
              " " +
              new Date(props.clientsData.dateWym).getFullYear() +
              " r.",
            zab_wn:
              props.clientsData.application_for_protection === "TAK"
                ? "z wnioskiem o zabezpieczenie"
                : "",
            pod_um_kr:
              props.clientsData.bank_old !== ""
                ? `(następcą prawnym: ${props.clientsData.bank_old})`
                : "",
            pod_um_kr_bool: props.clientsData.bank_old !== "" ? true : false,
            bank_pod:
              props.clientsData.bank_old !== ""
                ? props.clientsData.bank_old
                : bankAddressDb.nameLetter,
            creditNumber: props.clientsData.credit_aggr_num,
            real_cr_value: numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.realCreditValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            ),
            curr: curr,
            curr_old: curr_old,
            year_cr_date: new Date(props.clientsData.credit_date).getFullYear(),
            creditDate:
              (new Date(props.clientsData.credit_date).getDate() < 10
                ? "0" + new Date(props.clientsData.credit_date).getDate()
                : new Date(props.clientsData.credit_date).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.credit_date).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.credit_date).getFullYear() +
              " r.",
            petitioner: props.clientsData.petitioner.replaceAll("  ", ""),
            zast_text:
              props.clientsData.petitioner.replaceAll("  ", "").split(",")
                .length > 1
                ? "zastępowani"
                : "zastępowany",
            plnValue: plnValueTr,
            plnValueA: plnValueTrA,
            plnValue2: plnValueTr4,
            plnText: plnTextTr,
            chfValue:
              +chfValue !== undefined
                ? +chfValue.replaceAll(" ", "").replaceAll(",", ".") > 0
                  ? chfValueTr + " CHF"
                  : ""
                : "",
            chfText:
              +chfValue !== undefined
                ? +chfValue
                    .toString()
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0 &&
                  +plnValue
                    .toString()
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                  ? " oraz "
                  : ""
                : "",
            chf_add_text:
              +props.clientsData.wezwChfValue
                .toString()
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0
                ? "od obu wskazanych kwot"
                : "",
            aggr_points: aggr_points,

            payed_cr: payed === "TAK" ? true : false,
            payed_add_cr: getList("payed_add_tr"),
            lawsuit_att_cr: getList("lawsuit_att_tr"),

            raiffeisen_text: props.clientsData.bank.includes("Raiffeisen")
              ? getList("raiffeisen_text")
              : "",

            mbank_spl: props.clientsData.bank.includes("mBank")
              ? `Zgodnie z aktualnym stanowiskiem Sądu Najwyższego wyrażonym w postanowienia z dnia 7 lutego 2023 r., sygn. akt: I CSK 4195/22 (www.sn.pl) nie ma możliwości usunięcia części nieuczciwego elementu warunku umowy poprzez wykreślenie ze spornej umowy kredytu § 17 marży kupna/marży sprzedaży. Sąd Najwyższy wskazał, że „z wyroku TSUE wydanego w sprawie C-19/20 nie wynika jednolity sposób traktowania zobowiązania do uiszczenia na rzecz kredytującego banku marży. Zobowiązanie takie wynika bowiem z treści konkretnej umowy zawieranej przez strony i podlega zasadom wykładni oświadczeń woli. Wykładnia ta, dokonywana w każdym przypadku, prowadzi do ustalenia treści normy wynikającej z interpretowanego postanowienia umownego. W przypadku umowy badanej w niniejszej sprawie jednak Sąd odwoławczy ustalił, że kwestionowane klauzule indeksacyjne dotyczą w równym stopniu wyliczenia samego zobowiązania kredytowego (świadczenia głównego), sposobu kalkulacji należnych rat, jak i naliczania marży. Z tej przyczyny nie znalazł podstaw do wyinterpretowania oddzielnej normy prawnej odnoszącej się wyłącznie do marży banku.”
              Zgadzając się ze wskazanym poglądem dodać można, że mimo różnych sposobów redakcyjnego ujęcia kwestii odwołania do tabeli kursowej wciąż można mówić o jednym tylko świadczeniu kredytodawcy i kredytobiorcy, spełnianych wzajemnie w celu uzyskania świadczenia drugiej strony. Ostatecznie bowiem było przewidziane jedno świadczenie w wysokości wynikającej z tabeli kursowej banku, bez wyodrębnienia świadczenia spełnianego wg średniego kursu NBP i świadczenia stanowiącego marżę banku. Przedstawione ujęcie odpowiada dotychczasowej praktyce orzeczniczej Sądu Najwyższego, który opowiada się za potrzebą kompleksowej oceny klauzuli waloryzacyjnej (zob. wyrok SN z 11 grudnia 2019 r. V CSK 382/18). Przedstawione ujęcie i brak możliwości usunięcia jedynie marży z umowy potwierdza szereg orzeczeń sądów powszechnych (zob. wyroki Sądu Apelacyjnego w Gdańsku z dnia: 9.06.2021 r. V ACa 127/21, 04.02.2022 V ACa 340/21, 19.11.2021 V ACa 256/21, 15.12.2021 I ACa 396/21, z 11.01.2022 I ACa 750/21, 23.11.2021 V ACa 77/21, 15.12.2021 I ACa 396/21; wyroki Sądu Apelacyjnego we Wrocławiu z: 22.04.2022 I ACa 1273/21, 22.02.2022 I ACa 1462/21, 20.01.2022 I ACa 551/21, wyrok Sądu Apelacyjnego w Szczecinie z 28.04.2022 I ACa 887/21, wyrok Sądu Apelacyjnego w Warszawie z 20.04.2022 VI ACa 395/21, wyrok Sądu Apelacyjnego w Poznaniu z 18.02.2022 I ACa 277/21, wyroki Sądu Apelacyjnego w Katowicach z: 07.03.2022 VI ACa 671/21, 21.01.2022 I ACa 248/21.
              Jak trafnie wskazał Sąd Apelacyjny w Katowicach w wyroku z dnia 21 czerwca 2022 r. I ACa 111/22 LEX nr 3370693: „klauzuli indeksacyjnej dotyczącej marży Banku (§ 17 umowy) nie można zakwalifikować jako zobowiązania umownego odrębnego od innych postanowień umownych, ponieważ wykładni ust. 2-4 § 17 umowy nie można dokonywać z pominięciem § 1, zgodnie z którym "do rozliczania transakcji wypłat i spłat kredytów stosowane są odpowiednio kursy kupna/sprzedaży dla kredytów hipotecznych (...) walut zawartych w ofercie Banku obowiązujące w dniu dokonania transakcji", a więc do rozliczenia transakcji wypłaty stosowany był kurs kupna CHF, zaś do rozliczenia spłaty - kurs sprzedaży CHF, co stanowiło ogólną zasadę wynikającą z umowy. (…) W rezultacie, klauzula indeksacyjna w tym wypadku nie tyle kreowała odrębne zobowiązanie, ile stanowiła element precyzujący zobowiązanie w zakresie określenia wysokości świadczenia głównego stron - wysokości wypłaconego kredytu oraz wysokości spłacanych rat. Dodatkowo określony w § 17 mechanizm indeksacyjny uwzględniający także spread walutowy jest ze sobą wewnętrznie powiązany w taki sposób, że wyeliminowanie elementu dotyczącego marży spowodowałby zmianę istoty treści klauzuli indeksacyjnej. Wyeliminowanie elementu dotyczącego marży spowodowałoby bowiem, że kurs kupna i sprzedaży waluty CHF rozumiany byłby wyłącznie jako "średni kurs złotego do danej waluty ogłoszony w tabeli kursów NBP", a taki zabieg stanowiłby zdaniem sądu drugiej instancji niedopuszczalne przeprowadzenie redukcji utrzymującej skuteczność abuzywnej klauzuli waloryzacyjnej, przez podzielenie jej na część wadliwą i dopuszczalną, co zupełnie zmieniałoby sens § 17 umowy, zwłaszcza że mechanizm indeksacyjny należy rozumieć kompleksowo.” 
              `
              : "",
            normal_text:
              !props.clientsData.bank.includes("Raiffeisen") &&
              !props.clientsData.bank.includes("mBank")
                ? getList("normal_text")
                : "",

            mbank_text: props.clientsData.bank.includes("mBank")
              ? getList("mbank_text")
              : "",

            date_wezw:
              (new Date(props.clientsData.data_wezw).getDate() < 10
                ? "0" + new Date(props.clientsData.data_wezw).getDate()
                : new Date(props.clientsData.data_wezw).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.data_wezw).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.data_wezw).getFullYear() +
              " r.",
            hasZab:
              props.clientsData.application_for_protection === "TAK"
                ? true
                : false,
            wn_zab_text:
              props.clientsData.application_for_protection === "TAK"
                ? text.filter((el) => el.topic === "wn_zab_text").length > 0
                  ? text.filter((el) => el.topic === "wn_zab_text")[0].name
                  : ""
                : "",
            wn_zab_text2:
              props.clientsData.application_for_protection === "TAK"
                ? getList("wn_zab_text2")
                : "",
            date_dor_wezw:
              (new Date(props.clientsData.dateDeliverWezw).getDate() < 10
                ? "0" + new Date(props.clientsData.dateDeliverWezw).getDate()
                : new Date(props.clientsData.dateDeliverWezw).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.dateDeliverWezw).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.dateDeliverWezw).getFullYear() +
              " r.",
            pay_time: props.clientsData.wezwPayTime.replaceAll(" dni", ""),
            date_wym_sub:
              (new Date(subDay(props.clientsData.dateWym)).getDate() < 10
                ? "0" + new Date(subDay(props.clientsData.dateWym)).getDate()
                : new Date(subDay(props.clientsData.dateWym)).getDate()) +
              " " +
              getMonthName(
                new Date(subDay(props.clientsData.dateWym)).getMonth() + 1
              ) +
              " " +
              new Date(subDay(props.clientsData.dateWym)).getFullYear() +
              " r.",
            credit_value: creditValueText,
            chf_credit_value_text0:
              indexed === "TAK" &&
              props.clientsData.credit_value.split(" ")[1] === "PLN" &&
              (props.clientsData.nadCHF
                ? +props.clientsData.nadCHF
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") === 0
                : false) &&
              (props.clientsData.wezwChfValue
                ? +props.clientsData.wezwChfValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") === 0
                : false) &&
              ((props.clientsData.nadPLN
                ? +props.clientsData.nadPLN
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                : false) ||
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0)
                ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, zaokrąglając do pełnych złotych (${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.credit_value
                          .replaceAll(" ", "")
                          .replaceAll("CHF", "")
                          .replaceAll("PLN", "")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN + ${plnValueTr} PLN).`
                : "",
            chf_credit_value_text:
              indexed === "TAK" &&
              props.clientsData.credit_value.split(" ")[1] === "PLN" &&
              ((props.clientsData.nadCHF
                ? +props.clientsData.nadCHF
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                : false) ||
                (props.clientsData.wezwChfValue
                  ? +props.clientsData.wezwChfValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") > 0
                  : false)) &&
              ((props.clientsData.nadPLN
                ? +props.clientsData.nadPLN
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                : false) ||
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0)
                ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, a kwotę w CHF przeliczono na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.credit_value
                          .replaceAll(" ", "")
                          .replaceAll("CHF", "")
                          .replaceAll("PLN", "")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN + ${plnValueTr} PLN + ${chfValueTr} CHF x ${curr}), zaokrąglając następnie do pełnych złotych.`
                : "",
            chf_credit_value_text2:
              indexed === "NIE" &&
              +props.clientsData.realCreditValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0 &&
              ((props.clientsData.nadPLN
                ? +props.clientsData.nadPLN
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                : false) ||
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0) &&
              (+props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === undefined ||
                +props.clientsData.wezwChfValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === 0 ||
                (props.clientsData.nadCHF
                  ? +props.clientsData.nadCHF
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") === undefined
                  : false) ||
                (props.clientsData.nadCHF
                  ? +props.clientsData.nadCHF
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") === 0
                  : false))
                ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę rzeczywiście wypłaconego kredytu, zaokrąglając do pełnych złotych (${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        +props.clientsData.realCreditValue
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN + ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.nadPLN
                          ? +props.clientsData.nadPLN
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                          : +props.clientsData.wezwPlnValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN).`
                : "",
            chf_credit_value_text3:
              indexed === "NIE" &&
              +props.clientsData.realCreditValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0 &&
              ((props.clientsData.nadPLN
                ? +props.clientsData.nadPLN
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                : false) ||
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0) &&
              ((props.clientsData.nadCHF
                ? +props.clientsData.nadCHF
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                : false) ||
                +props.clientsData.wezwChfValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0)
                ? `WPS obliczono jako sumę żądań głównych o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę rzeczywiście wypłaconego kredytu, tj. ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        +props.clientsData.realCreditValue
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN, a kwotę żądania wyrażonego w CHF przeliczono na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.nadPLN
                          ? +props.clientsData.nadPLN
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                          : +props.clientsData.wezwPlnValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN + ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.nadCHF
                          ? +props.clientsData.nadCHF
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                          : +props.clientsData.wezwChfValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} CHF x ${curr} + ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        +props.clientsData.realCreditValue
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN), zaokrąglając następnie do pełnych złotych.`
                : "",
            chf_credit_value_text4:
              indexed === "NIE" &&
              (+props.clientsData.realCreditValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === undefined ||
                +props.clientsData.realCreditValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === 0) &&
              ((props.clientsData.nadPLN
                ? +props.clientsData.nadPLN
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") > 0
                : false) ||
                +props.clientsData.wezwPlnValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") > 0) &&
              (+props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0 ||
                (props.clientsData.nadCHF
                  ? +props.clientsData.nadCHF
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") > 0
                  : false))
                ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, tj. ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        +props.clientsData.credit_value
                          .split(" ")[0]
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} CHF. Kwotę kredytu i roszczenie wyrażone w CHF Powód przeliczył na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.nadPLN
                          ? +props.clientsData.nadPLN
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                          : +props.clientsData.wezwPlnValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN + ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.nadCHF
                          ? +props.clientsData.nadCHF
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                          : +props.clientsData.wezwChfValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} CHF x ${curr} + ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.credit_value
                          .replaceAll("CHF", "")
                          .replaceAll("PLN", "")
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} CHF x ${curr}), zaokrąglając następnie do pełnych złotych.`
                : "",
            chf_credit_value_text5:
              indexed === "NIE" &&
              (+props.clientsData.realCreditValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === undefined ||
                +props.clientsData.realCreditValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === 0) &&
              (+props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0 ||
                (props.clientsData.nadPLN
                  ? +props.clientsData.nadPLN
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") > 0
                  : false)) &&
              (+props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === undefined ||
                +props.clientsData.wezwChfValue
                  .replaceAll(" ", "")
                  .replaceAll(",", ".") === 0 ||
                (props.clientsData.nadCHF
                  ? +props.clientsData.nadCHF
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") === undefined
                  : false) ||
                (props.clientsData.nadCHF
                  ? +props.clientsData.nadCHF
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") === 0
                  : false))
                ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, tj. ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.credit_value
                          .replaceAll("CHF", "")
                          .replaceAll("PLN", "")
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} CHF. Roszczenie wyrażone w CHF Powód przeliczył na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        props.clientsData.nadPLN
                          ? +props.clientsData.nadPLN
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                          : +props.clientsData.wezwPlnValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN + ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        +props.clientsData.credit_value
                          .replaceAll("CHF", "")
                          .replaceAll("PLN", "")
                          .replaceAll(" ", "")
                          .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} CHF x ${curr}), zaokrąglając następnie do pełnych złotych.`
                : "",
            wn_zab_long_text:
              props.clientsData.application_for_protection === "TAK"
                ? `Uzasadnienie wniosku o zabezpieczenie
            Powód regularnie uiszcza raty kapitałowo-odsetkowe na podstawie umowy, która z dużym prawdopodobieństwem będzie uznana za nieważną. W razie stwierdzenia abuzywności klauzuli ryzyka walutowego TSUE uznaje bowiem, że utrzymanie umowy "nie wydaje się możliwe z prawnego punktu widzenia", co dotyczy także klauzul przeliczeniowych przewidujących spread walutowy. Analiza orzecznictwa TSUE doprowadziła Sąd Najwyższy w wyroku z dnia 11 grudnia 2019 r. (V CSK 382/18) do konstatacji, że brak jest możliwości utrzymania skuteczności umowy kredytu złotowego, waloryzowanego do waluty obcej, mimo wyeliminowania klauzul analogicznych do klauzul kwestionowanych przez Powoda w niniejszym postepowaniu. W związku z powyższym, niecelowe jest, aby Powód spłacał swój kredyt w toku procesu, albowiem Powód w dotychczasowym wykonaniu umowy oddał bankowi łącznie kwotę wyższą niż kwota udostępnionego przez bank kredytu. Powód spłacił łącznie kwotę ${plnValueTr3} PLN${
                    +props.clientsData.wezwChfValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") > 0
                      ? `, tj. ${plnValueTrA} PLN oraz ${chfValueTr} CHF, (przy czym kwotę w CHF przeliczono na PLN wg kursu średniego CHF na dzień sporządzenia pozwu – ${chfValueTr} CHF x ${curr})`
                      : " "
                  }, podczas gdy Pozwany wypłacił mu kwotę ${numberWithCommas(
                    parseFloat(
                      parseFloat(
                        +props.clientsData.realCreditValue
                          .replaceAll(" ", "")
                          .replaceAll(",", ".") > 0
                          ? +props.clientsData.realCreditValue
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                          : props.clientsData.credit_value
                              .replaceAll("CHF", "")
                              .replaceAll("PLN", "")
                              .replaceAll(" ", "")
                              .replaceAll(",", ".")
                      ).toFixed(2)
                    ).toFixed(2)
                  )} PLN. Dalsze uiszczanie przez Powoda rat kredytu, tj. spełnianie świadczenia, co do którego na obecnym etapie postępowania uznać należałoby, że posiada oparcie w abuzywnym postanowieniu umownym, doprowadziłoby do nieuczciwego, niezasadnego obciążenia Powoda i bezpodstawnego wzbogacania Pozwanego, zwiększając skalę prawdopodobnych przyszłych rozliczeń między stronami koniecznych w przypadku stwierdzenia nieważności umowy. 
            Celem powództwa o ustalenie jest definitywne rozwiązanie powstałych na tym tle sporów pomiędzy stronami. Odmowa zabezpieczenia oznaczałaby zgodę na wykonywanie nieważnej umowy i mogłaby skutkować koniecznością wytoczenia kolejnego powództwa o zapłatę, aby zrealizować w pełni skutek wynikający z uznania określonych postanowień za abuzywne. Wstrzymanie obowiązku spłaty rat na czas trwania procesu, które z racji nieważności umowy nie są należne, pozwala na uniknięcie kolejnego procesu o ich zwrot. Kolejne postępowanie o zapłatę należałoby traktować jako utrudnienie realizacji celu niniejszego postępowania, którym jest definitywne rozstrzygnięcie sporu pomiędzy stronami (por. Sąd Okręgowy w Warszawie w postanowieniu z dnia 6 lipca 2021 r., sygn. XXVIII C 7900/21). Brak zabezpieczenia zgłoszonego żądania o ustalenie sprawi natomiast, że Powód - który spłacił już kwotę przekraczającą kapitał – będzie zobowiązany dalej dokonywać spłat. Właśnie w tego rodzaju sytuacji - uprawdopodobnieniu, iż wskutek dalszego wykonywania umowy należność Powoda będzie narastać, przy jednoczesnym obciążeniu Powoda miesięcznymi ratami – należy upatrywać poważnego utrudnienia osiągnięcia celu postępowania (por. Sąd Apelacyjny w Warszawie w postanowieniu z dnia 1 kwietnia 2020 r., sygn. akt VI ACz 1137/19). Jak wskazał Sąd Apelacyjny w Poznaniu w postanowieniu z 13 września 2022 r. (XVIII Cz 132/22), spłacanie jakichkolwiek należności na rzecz banku, w sytuacji gdy już uiszczone na jego rzecz kwoty przewyższyły wypłacony przez bank kapitał, byłoby pogwałceniem słusznych interesów powoda. 
            Podkreślenia wymaga, że zgodnie z wyrokiem TSUE z dnia 26 czerwca 2019 r. w sprawie C-407/18: niezgodne z przepisami powołanej dyrektywy są regulacje krajowe, które uniemożliwiają sądowi zawieszenie postępowania egzekucyjnego do czasu zbadania podniesionych przez konsumenta zarzutów abuzywności umowy. Skoro dopuszczalne jest zabezpieczenie roszczenia konsumenta poprzez zawieszenie postępowania egzekucyjnego zmierzającego do wykonania potencjalnie abuzywnych postanowień umowy, to tym bardziej dopuszczalne jest czasowe wstrzymanie wykonywania umowy tego rodzaju. Zważyć trzeba, że rozumienie interesu prawnego w udzieleniu zabezpieczenia należy rozumieć szeroko, w sposób zapewniający maksymalne zastosowanie regulacji płynących z prawa europejskiego. Istotą niniejszej sprawy jest ochrona konsumenta przed skutkami mogącymi wypływać z tytułu niedozwolonej treści postanowień określających mechanizm waloryzacji. Roszczenie o ustalenie nieistnienia stosunku prawnego stanowi konieczny wyraz tej ochrony, albowiem usuwa ono kompleksowo stan nierównowagi kontraktowej między stronami wywołany wprowadzonymi przez bank do umowy klauzulami abuzywnymi.
            Ponadto, należy mieć na uwadze wyrok TSUE z dnia 15 czerwca 2023 r., sygn. akt C-287/22, zgodnie z którym ,,art. 6 ust. 1 i art. 7 ust. 1 dyrektywy 93/13 w sprawie nieuczciwych warunków w umowach konsumenckich należy interpretować w ten sposób, że stoją one na przeszkodzie orzecznictwu krajowemu, zgodnie z którym sąd krajowy może oddalić złożony przez konsumenta wniosek o zastosowanie środków tymczasowych mających na celu zawieszenie, w oczekiwaniu na ostateczne rozstrzygnięcie w przedmiocie unieważnienia zawartej przez tego konsumenta umowy kredytu ze względu na to, że owa umowa kredytu zawiera nieuczciwe warunki, spłaty rat miesięcznych należnych na podstawie wspomnianej umowy kredytu, w sytuacji gdy zastosowanie takich środków tymczasowych jest konieczne dla zapewnienia pełnej skuteczności tego orzeczenia.”. Jak wskazał TSUE, odmowa zawieszenia spłaty rat kredytu w ramach zabezpieczenia roszczenia mogłaby doprowadzić, przynajmniej w części, do nieskuteczności ostatecznego orzeczenia co do nieważności umowy. Takie orzeczenie nie skutkowałoby przywróceniem sytuacji prawnej i faktycznej, w jakiej znajdowałby się kredytobiorca w braku nieuczciwego warunku, gdyż jedynie część zapłaconej kwoty mogłaby być przedmiotem ostatecznego orzeczenia. Wobec powyższego zastosowanie zabezpieczenia roszczenia poprzez zawieszenie płatności rat kredytu jest konieczne dla zapewnienia pełnej skuteczności przyszłego orzeczenia.
            `
                : "",
            last_pay_date: props.clientsData.wezwLastPayDate,
            aggr_bank: props.clientsData.bank,
            raiffeisen_text_2: props.clientsData.bank.includes("Raiffeisen")
              ? getList("raiffeisen_text_2")
              : "",
            mbank_text_2: props.clientsData.bank.includes("mBank")
              ? getList("mbank_text_2")
              : "",
            normal_text_2:
              !props.clientsData.bank.includes("Raiffeisen") &&
              !props.clientsData.bank.includes("mBank")
                ? getList("normal_text_2")
                : "",
            koSkd: props.clientsData.koSkd
              ? props.clientsData.koSkd.replaceAll(".", ",")
              : "",
            kpSkd: props.clientsData.kpSkd
              ? props.clientsData.kpSkd.replaceAll(".", ",")
              : "",
            kupSkd: props.clientsData.kupSkd
              ? props.clientsData.kupSkd.replaceAll(".", ",")
              : "",
            irSkd: props.clientsData.irSkd,
            izrSkd: props.clientsData.izrSkd,
          });
          try {
            doc.render();
          } catch (error) {
            function replaceErrors(key, value) {
              if (value instanceof Error) {
                return Object.getOwnPropertyNames(value).reduce(function (
                  error,
                  key
                ) {
                  error[key] = value[key];
                  return error;
                },
                {});
              }
              return value;
            }

            if (error.properties && error.properties.errors instanceof Array) {
              const errorMessages = error.properties.errors
                .map(function (error) {
                  return error.properties.explanation;
                })
                .join("\n");
            }
            throw error;
          }
          var out = doc.getZip().generate({
            type: "blob",
            mimeType:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          saveAs(
            out,
            "Pozew_" + props.clientsData.petitioner.replaceAll("  ", "")
          );

          MySwal.fire({
            title: "Czy chcesz zapisać pismo w systemie?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then(async (result) => {
            if (result.isConfirmed) {
              let formData = new FormData();
              formData.append("file", out);
              formData.append("type", "auto");
              formData.append("clientId", props.clientsData.id);
              formData.append("taskId", "");
              formData.append("user", props.userName);
              formData.append(
                "name",
                getTemplateName(template) + "_" + props.clientsData.petitioner
              );

              await fetch("https://apidevkppp.ftpeople.pl/uploadFileAutoPDF", {
                method: "POST",
                body: formData,
              })
                .then((response) => {
                  props.close();
                })
                .then((responseJson) => {});
            } else if (result.isDenied) {
              props.close();
            }
          });
        });
      }
    });
  };

  function getNextFriday(date) {
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
      dateCopy.setDate(
        dateCopy.getDate() + ((7 - dateCopy.getDay() + 5) % 7 || 7)
      )
    );

    return nextFriday;
  }

  const getTemplateName = (value) => {
    return "Pozew";
  };

  const handlePetitionersChange = (e) => {
    setPetitioners(e.target.value);
  };

  const handleIndexedChange = (e) => {
    setIndexed(e.target.value);
  };

  const handlePayedChange = (e) => {
    setPayed(e.target.value);
  };

  const setDateOptF = (e) => {
    setDateOpt(e.target.value);
    if (e.target.value === "1") {
      setLastPaymentDate("");
    } else {
      setLastPaymentDate("całkowitej spłaty kredytu");
    }
  };

  return (
    <div
      style={{ width: "50vw", top: "25vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div
            id="addPaymentIC"
            className="inputContainer"
            style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
          >
            {questions
              ? questions.map((q, index) => (
                  <div className="inputBox" style={{ width: "40%" }}>
                    <div className="inputCol_2" style={{ minWidth: "100%" }}>
                      <label>
                        {q.name}
                        <span className="requiredStar">*</span>
                      </label>
                      <select
                        type="text"
                        id="court"
                        name="court"
                        value={
                          checklist.filter((e) => e.index === index)[0]
                            ? checklist.filter((e) => e.index === index)[0]
                                .result
                            : "TAK"
                        }
                        onChange={(e) => {
                          if (checklist.filter((e) => e.index === index)[0]) {
                            checklist.filter(
                              (e) => e.index === index
                            )[0].result = e.target.value;
                          }
                        }}
                      >
                        {template === "" ? (
                          <option key={0} value={""}>
                            {"Wybierz..."}
                          </option>
                        ) : (
                          ""
                        )}
                        <option key={1} name={"TAK"} value={"TAK"}>
                          {"TAK"}
                        </option>
                        <option key={2} name={"NIE"} value={"NIE"}>
                          {"NIE"}
                        </option>
                      </select>
                    </div>
                  </div>
                ))
              : "ładuje pytania..."}

            <div className="saveBoxAP" style={{ width: "100%" }}>
              <button className="paymentMenuButton" onClick={generateDocument}>
                Wygeneruj
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddLawsuit;
